import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Table, Button, Form, Spin, message, Card, Typography} from 'antd';
import {
    SaveOutlined,
    ArrowLeftOutlined,
    ReloadOutlined,
    CarOutlined
} from '@ant-design/icons';
import _ from "lodash";
import {useTranslation} from "react-i18next";
import InvoiceDetailsModal from '../facturas/InvoiceDetailsModal';
import GlobalSelect from "../../generales/GlobalSelect";
import {Link} from "react-router-dom";

const { Title } = Typography;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

function VehicleAssignment() {

    const {t, i18n} = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [form] = Form.useForm();
    const [formBuscarFactura] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar el modal
    const [isModalBuscarFacturaOpen, setIsModalBuscarFacturaOpen] = useState(false); // Estado para controlar el modal
    const [spinning, setSpinning] = useState(false);
    const [spinTitle, setSpinTitle] = useState(t('global.loading'));
    const [bottom, setBottom] = useState('bottomCenter');
    const [messageApi, contextHolder] = message.useMessage();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isModalOpenDetalles, setIsModalOpenDetalles] = useState(false); // Estado para controlar el modal
    const [selectedInvoice, setSelectedInvoice] = useState(null); // Almacenar la factura seleccionada
    const [vehiculo, setVehiculo] = useState([]);
    const [dataRecord, setDataRecord] = useState([]);


    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
    };

    useEffect(() => {
        recargar();
        cargarVehiculosDisponibles();
    }, []);

    const cargarVehiculosDisponibles = () => {
        setSpinning(true);
        let aux = [];
        // let start = 0;
        // let limit = 1000;

        Axios.post("sd/getVehiculosDisponibles",
            {
                // "start": start,
                // "limit": limit,
                // "filtros": {
                //     "idrol": 4
                // }
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.data.length > 0) {
                for (let i = 0; i < response.data.data.length; i++) {
                    aux.push({
                        id: response.data.data[i].idvehiculo,
                        // matricula:response.data.data[i].matricula,
                        // vehiculo:response.data.data[i].vehiculo,
                        // tipo_vehiculo:response.data.data[i].tipo_vehiculo,
                        nombre: response.data.data[i].vehiculo
                    });
                }
            }
            setVehiculo(aux);
        }).catch(error => {
            setSpinning(false);
            setVehiculo(aux);
        })
    };

    const recargar = (resetVehiculo = true) => {

        setSpinTitle(t('global.loading'));
        setSpinning(true);

        if (resetVehiculo) {
            resetSelect();
        }
        handleDeselectAll();

        // setSelectedRowKeys([]);
        let aux = [];

        // let start = 0;
        // let limit = 1000;

        Axios.post("sd/getFacturas",
            {
                // "start": start,
                // "limit": limit,
                "filtros": [{
                    "asignada": 0
                }]
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);

            // Asumiendo que response.data.data es un array
            const rawData = response.data.data;

            // No necesitas usar Object.keys, solo asigna rawData directamente
            const formattedData = rawData.map(item => ({
                code: item.code,
                idinvoice: item.idinvoice,
                rdatereserve: item.rdatereserve,
                cname: item.cname,
                cidentity: item.cidentity,
                address: item.address,
                cprovince: item.cprovince,
                cmunicipality: item.cmunicipality,
                sname: item.sname,
                idestadoinvoice: item.idestadoinvoice,
                estadoinvoice: item.estadoinvoice,
                prioridad: item.prioridad,
                latitude: item.latitude,
                longitude: item.longitude,
                coordinates: item.coordinates,
                products: JSON.parse(item.products)  // Asegúrate de que el valor sea un array
            }));

            // console.log(formattedData);
            setData(formattedData);

        }).catch(error => {
            setSpinning(false);
        });

    };
    const filterData = data => formatter => data.map( item => ({
        text: formatter(item),
        value: formatter(item)
    }));

    const showModalVerDetalles = (record) => {
        setSelectedInvoice(record); // Guardar la factura seleccionada
        setIsModalOpenDetalles(true); // Mostrar el modal
    };

    const handleCancelVerDetalles = () => {
        setIsModalOpenDetalles(false); // Cerrar el modal
        setSelectedInvoice(null); // Limpiar la factura seleccionada
    };

    const columns = [
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_identificador')}
                </span>
            ),
            dataIndex: 'code',
            key: 'code',
            width: 120,
            fixed: 'left',
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.code), _.isEqual),
            onFilter: (value, record) => record.code.startsWith(value),
            sorter: (a, b) => a.code.localeCompare(b.code),
            render: (text, record) => (
                <Button
                    type="link"
                    onClick={() => showModalVerDetalles(record)}
                    style={{
                        color: '#253289',
                        fontWeight: '500',
                        padding: 0
                    }}
                >
                    {text}
                </Button>
            )
        },{
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_fecha_reserva')}
                </span>
            ),
            dataIndex: 'rdatereserve',
            key: 'rdatereserve',
            width: 130,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.rdatereserve), _.isEqual),
            onFilter: (value, record) => record.rdatereserve.startsWith(value),
            sorter: (a, b) => a.rdatereserve.localeCompare(b.rdatereserve)
        },
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_destinatario')}
                </span>
            ),
            dataIndex: 'cname',
            key: 'cname',
            width: 200,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.cname), _.isEqual),
            onFilter: (value, record) => record.cname.startsWith(value),
            sorter: (a, b) => a.cname.localeCompare(b.cname),
            ellipsis: true
        },
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_identidad')}
                </span>
            ),
            dataIndex: 'cidentity',
            key: 'cidentity',
            width: 120,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.cidentity), _.isEqual),
            onFilter: (value, record) => record.cidentity.startsWith(value),
            sorter: (a, b) => a.cidentity.localeCompare(b.cidentity)
        },
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_direccion')}
                </span>
            ),
            dataIndex: 'address',
            key: 'address',
            width: 180,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.address), _.isEqual),
            onFilter: (value, record) => record.address.startsWith(value),
            sorter: (a, b) => a.address.localeCompare(b.address),
            ellipsis: true
        },
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_municipio')}
                </span>
            ),
            dataIndex: 'cmunicipality',
            key: 'cmunicipality',
            width: 140,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.cmunicipality), _.isEqual),
            onFilter: (value, record) => record.cmunicipality.startsWith(value),
            sorter: (a, b) => a.cmunicipality.localeCompare(b.cmunicipality),
            ellipsis: true
        },
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_provincia')}
                </span>
            ),
            dataIndex: 'cprovince',
            key: 'cprovince',
            width: 130,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.cprovince), _.isEqual),
            onFilter: (value, record) => record.cprovince.startsWith(value),
            sorter: (a, b) => a.cprovince.localeCompare(b.cprovince),
            ellipsis: true
        },
        {
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_remitente')}
                </span>
            ),
            dataIndex: 'sname',
            key: 'sname',
            width: 160,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.sname), _.isEqual),
            onFilter: (value, record) => record.sname.startsWith(value),
            sorter: (a, b) => a.sname.localeCompare(b.sname),
            ellipsis: true
        },{
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_stateinvoice')}
                </span>
            ),
            dataIndex: 'estadoinvoice',
            key: 'estadoinvoice',
            width: 140,
            filterSearch: true,
            filters: _.uniqWith(filterData(data)(i => i.estadoinvoice), _.isEqual),
            onFilter: (value, record) => record.estadoinvoice.startsWith(value),
            sorter: (a, b) => a.estadoinvoice.localeCompare(b.estadoinvoice),
            render: (text) => (
                <span style={{
                    padding: '4px 8px',
                    borderRadius: '4px',
                    background: '#f0f6ff',
                    color: '#253289',
                    fontSize: '12px',
                    fontWeight: '500'
                }}>
                    {text}
                </span>
            )
        },{
            title: (
                <span style={{
                    fontWeight: '600',
                    color: '#253289',
                    fontSize: '13px'
                }}>
                    {t('invoice.col_priority')}
                </span>
            ),
            dataIndex: 'prioridad',
            key: 'prioridad',
            width: 100,
            filters: Array.from(new Set(data.map(item => item.prioridad)))
                          .sort((a, b) => a - b)
                          .map(p => ({ text: String(p), value: p })),
            onFilter: (value, record) => record.prioridad === value,
            sorter: (a, b) => a.prioridad - b.prioridad,
            render: prioridad => (
                <span style={{
                    background: prioridad === 1 ? '#fff2e8' : prioridad === 2 ? '#f6ffed' : '#f0f6ff',
                    color: prioridad === 1 ? '#d4380d' : prioridad === 2 ? '#389e0d' : '#253289',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: '600',
                    display: 'inline-block',
                    minWidth: '20px',
                    textAlign: 'center'
                }}>
                    {String(prioridad)}
                </span>
            )
        }
          
        /*{
            title: <p style={{
                margin: "0px 0",
                fontSize: "15px",
                fontWeight: "bold",
                color: "#2c3e50",
                fontFamily: "'Roboto', sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.2)"
            }}>{t('invoice.col_priority')}</p>,
            dataIndex: 'prioridad',
            key: 'prioridad',
            filterSearch: true,
            width: 150,
            filters: _.uniqWith(filterData(data)(i => i.prioridad), _.isEqual),
            onFilter: (value, record) => record.prioridad.startsWith(value),
            sorter: (a, b) => String(a.prioridad).localeCompare(String(b.prioridad))
        }*/
    ];

    const productColumns = [
        {
            title: t('invoice.col_nombre_producto'),
            dataIndex: 'namegood',
            key: 'namegood',
        },
        {
            title: t('invoice.col_cantidad'),
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: t('invoice.col_peso'),
            dataIndex: 'weight',
            key: 'weight',
        },{
            title: t('invoice.col_longitud'),
            dataIndex: 'length',
            key: 'length',
        },{
            title: t('invoice.col_ancho'),
            dataIndex: 'width',
            key: 'width',
        },{
            title: t('invoice.col_alto'),
            dataIndex: 'height',
            key: 'height',
        },
        {
            title: t('invoice.col_dimensiones'),
            render: (text, record) => `${record.length} x ${record.width} x ${record.height} (cm)`,
            key: 'dimensions',
        },
    ];

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 20,
        total: data.length, // Asegúrate de tener el total de elementos aquí
    });

    const handleTableChange = (newPagination) => {
        setPagination({
            ...pagination,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        });
    };

    const expandedRowRender = (record) => {
        return <Table columns={productColumns} dataSource={record.products} pagination={false} rowKey="namegood" />;
    };

    //
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);

        if (newSelectedRowKeys.length === 1) {
            const selectedRow = data.find(row => row.code === newSelectedRowKeys[0]);
            // console.log("Selected Row: ", selectedRow);
            if (selectedRow) {
                // setDataRecord(selectedRow.cmunicipality + '. ' + selectedRow.cprovince);
                setDataRecord(selectedRow);
                // console.log(dataRecord);
            }
        }

    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const handleDeselectAll = () => {
        setSelectedRowKeys([]); // Esto desmarca todas las filas
    };
    const [selectedVehiculo, setSelectedVehiculo] = useState(null);

    const hasSelected = selectedRowKeys.length > 0;
    const hasVehicleSelected = selectedVehiculo !== null && selectedVehiculo !== undefined;
    const canAssign = hasSelected && hasVehicleSelected && !loading;
    const handleSelectChange = (value) => {
        setSelectedVehiculo(value); // Almacena el valor seleccionado
    };

    const handleSelectClear = () => {
        setSelectedVehiculo(null); // Limpia el valor cuando se usa el botón clear
    };
    // Resetear y limpiar el campo
    const resetSelect = () => {
        setSelectedVehiculo(null); // Reinicia el valor en el estado
        form.resetFields(['idvehiculo']); // Limpia el campo en el formulario
    };

    const asignarPaquetes = () => {

        setSpinTitle(t('global.processing_data'));
        setSpinning(true);

        Axios.post("sd/asignarPaqueteVehiculo",
            {
                "idvehiculo": selectedVehiculo,
                "idinvoice": selectedRowKeys
            },
            {
                headers: headers
            }
        ).then(response => {
            setSpinning(false);
            if (response.data.success) {
                messageApi.open({
                    type: 'success',
                    content: response.data.message || t('assignment.assign_success'),
                    duration: 2.5,
                });
                recargar(false); // No resetear el vehículo seleccionado
                cargarVehiculosDisponibles();
            } else {
                // Manejar ambos casos: message o error
                const errorMessage = response.data.message || response.data.error || t('assignment.assign_error');
                messageApi.open({
                    type: 'error',
                    content: errorMessage,
                    duration: 3,
                });
            }
        }).catch(error => {
            setSpinning(false);
            // Manejar errores de red y errores del servidor
            let errorMessage = t('assignment.assign_error');
            if (error.response?.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            } else if (error.message) {
                errorMessage = error.message;
            }
            messageApi.open({
                type: 'error',
                content: errorMessage,
                duration: 3,
            });
        });

    };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "16px"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <div style={{
                    maxWidth: "1400px",
                    margin: "0 auto"
                }}>
                    {/* Header Card */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '8px',
                        padding: '12px',
                        marginBottom: '12px',
                        color: 'white',
                        boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px'
                            }}>
                                <CarOutlined />
                            </div>
                            <div style={{ flex: 1 }}>
                                <Title level={4} style={{
                                    color: 'white',
                                    margin: 0,
                                    fontSize: '16px'
                                }}>
                                    {t('assignment.subtitle')}
                                </Title>
                                <p style={{
                                    color: 'rgba(255,255,255,0.8)',
                                    margin: 0,
                                    fontSize: '12px'
                                }}>
                                    Asignación de facturas a vehículos • {data.length} facturas disponibles
                                </p>
                            </div>
                            <div style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '8px',
                                padding: '8px 16px'
                            }}>
                                <p style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                                    {data.length} facturas
                                </p>
                            </div>
                        </div>
                    </div>

                    {contextHolder}

                    {/* Toolbar Card */}
                    <Card style={{
                        borderRadius: '8px',
                        marginBottom: '12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none'
                    }} styles={{ body: { padding: '12px' } }}>
                        <Form form={form} layout="vertical">
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                flexWrap: 'wrap'
                            }}>
                                <Link to="/assignment">
                                    <Button
                                        icon={<ArrowLeftOutlined />}
                                        disabled={loading}
                                        size="small"
                                        style={{
                                            borderColor: '#253289',
                                            color: '#253289',
                                            background: 'white',
                                            borderRadius: '8px',
                                            height: '32px',
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {t('assignment.back')}
                                    </Button>
                                </Link>

                                <div style={{
                                    height: '24px',
                                    width: '1px',
                                    background: '#e0e6ff'
                                }} />

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    flex: 1
                                }}>
                                    <span style={{
                                        color: '#253289',
                                        fontSize: '16px',
                                        fontWeight: '600'
                                    }}>
                                        {t('assignment.select')}:
                                    </span>
                                    <Form.Item
                                        name="idvehiculo"
                                        style={{
                                            margin: 0,
                                            minWidth: '250px'
                                        }}
                                        rules={[{required: true, message: 'Seleccione un vehículo'}]}
                                    >
                                        <GlobalSelect
                                            disabled={false}
                                            loading={spinning}
                                            valueName={'idvehiculo'}
                                            data={vehiculo}
                                            onSelect={handleSelectChange}
                                            onClear={handleSelectClear}
                                        />
                                    </Form.Item>
                                </div>

                                <Button
                                    icon={<SaveOutlined />}
                                    onClick={asignarPaquetes}
                                    disabled={!canAssign}
                                    size="large"
                                    style={{
                                        background: !canAssign
                                            ? '#d9d9d9'
                                            : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                        borderColor: !canAssign ? '#d9d9d9' : '#253289',
                                        color: !canAssign ? '#000000' : 'white',
                                        borderRadius: '8px',
                                        height: '32px',
                                        paddingLeft: '16px',
                                        paddingRight: '16px',
                                        fontWeight: '500',
                                        boxShadow: !canAssign
                                            ? 'none'
                                            : '0 2px 8px rgba(37, 50, 137, 0.3)'
                                    }}
                                    title={
                                        !hasSelected && !hasVehicleSelected
                                            ? 'Seleccione facturas y un vehículo'
                                            : !hasSelected
                                            ? 'Seleccione al menos una factura'
                                            : !hasVehicleSelected
                                            ? 'Seleccione un vehículo'
                                            : ''
                                    }
                                >
                                    {t('assignment.assign')}
                                </Button>

                                <Button
                                    icon={<ReloadOutlined />}
                                    onClick={recargar}
                                    loading={loading}
                                    size="large"
                                    style={{
                                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                        borderColor: '#253289',
                                        color: 'white',
                                        borderRadius: '8px',
                                        height: '32px',
                                        paddingLeft: '16px',
                                        paddingRight: '16px',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                    }}
                                >
                                    {t('invoice.update')}
                                </Button>
                            </div>
                        </Form>
                    </Card>

                    {/* Table Card */}
                    <Card style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: 'none'
                    }} styles={{ body: { padding: '0' } }}>
                        {/* Header de la tabla */}
                        <div style={{
                            background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                            padding: '12px 16px',
                            borderBottom: '1px solid #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                            }}>
                                <span style={{
                                    color: '#253289',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    📦 Facturas Disponibles
                                </span>
                                <span style={{
                                    background: selectedRowKeys.length > 0 ? '#f6ffed' : '#e3f2fd',
                                    color: selectedRowKeys.length > 0 ? '#389e0d' : '#253289',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    fontWeight: '500'
                                }}>
                                    {selectedRowKeys.length > 0 ? `${selectedRowKeys.length} seleccionadas` : `${data.length} disponibles`}
                                </span>
                                {selectedRowKeys.length > 0 && !hasVehicleSelected && (
                                    <span style={{
                                        background: '#fff2e8',
                                        color: '#d4380d',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        marginLeft: '8px'
                                    }}>
                                        ⚠️ Seleccione vehículo
                                    </span>
                                )}
                                {hasVehicleSelected && selectedRowKeys.length === 0 && (
                                    <span style={{
                                        background: '#fff2e8',
                                        color: '#d4380d',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        marginLeft: '8px'
                                    }}>
                                        ⚠️ Seleccione facturas
                                    </span>
                                )}
                                {canAssign && (
                                    <span style={{
                                        background: '#f6ffed',
                                        color: '#389e0d',
                                        padding: '4px 8px',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        marginLeft: '8px'
                                    }}>
                                        ✅ Listo para asignar
                                    </span>
                                )}
                            </div>
                        </div>

                        {error && <div>Error: {error}</div>}
                        <Table
                            dataSource={data}
                            columns={columns}
                            rowKey="idinvoice"
                            bordered={false}
                            expandable={{expandedRowRender}}
                            rowSelection={rowSelection}
                            onChange={handleTableChange}
                            scroll={{
                                x: 1400,
                                y: 500
                            }}
                            pagination={{
                                position: [bottom],
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                showSizeChanger: true,
                                pageSizeOptions: ['20', '40', '60', '80', '100'],
                                showTotal: (total, range) => (
                                    <span style={{
                                        color: '#253289',
                                        fontWeight: '500'
                                    }}>
                                        {`${range[0]}-${range[1]} de ${total} elementos`}
                                    </span>
                                ),
                                style: {
                                    marginTop: '16px'
                                }
                            }}
                            size="middle"
                            className="modern-table"
                            style={{
                                background: 'white',
                                borderRadius: '8px'
                            }}
                        />
                    </Card>

                    {/*detalles de la factura*/}
                    <InvoiceDetailsModal
                        isOpen={isModalOpenDetalles}
                        onCancel={handleCancelVerDetalles}
                        selectedInvoice={selectedInvoice}
                        productColumns={productColumns}
                    />
                </div>
            </Spin>
        </div>
    );
}

export default VehicleAssignment;
